'use strict';

var allowedFalseyValuePattern = /^(false|0)$/i;

module.exports = {
  normalizeBooleans: function normalizeBooleans(model, data) {
    var modelPropertyKeys = Object.keys(model.properties);
    var normalizedData = Object.assign({}, data);

    modelPropertyKeys.forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(normalizedData, key) && model.properties[key].type === 'boolean' && typeof normalizedData[key] !== 'boolean') {
        var value = normalizedData[key];
        var normalizedValue = !!value;

        // If still truthy, check against whitelist of explicit falsey values.
        if (normalizedValue && allowedFalseyValuePattern.test(value)) {
          normalizedValue = false;
        }

        normalizedData[key] = normalizedValue;
      }
    });

    return normalizedData;
  }
};